// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"c636a7b5","513":"c2bc9077","703":"0a6c62d5","787":"b59f86dc"}[chunkId] + ".chunk.js";
};